import { useInView } from 'react-intersection-observer';

import { useAppContext } from '@contexts/AppContext';

interface Props {
  ssr?: boolean,
  rootMargin?: string,
  threshold?: number,
  fallbackHeight?: string,
}

export const ViewportLazy: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ssr = false,
  rootMargin = '50px',
  threshold = 0.1,
  fallbackHeight = '20px',
}) => {
  const { isBot } = useAppContext();

  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin,
    threshold,
  });

  const shouldRender = inView || (ssr && isBot);

  return (
    <div
      ref={ref}
      style={{
        minHeight: shouldRender ? undefined : fallbackHeight,
      }}
    >
      {shouldRender ? children : null}
    </div>
  );
};
